import { Address } from '@/common/types';

const isAddressFilled = (address?: Address): boolean => {
  if (!address) return false;

  const fieldsToCheck = [
    address.line1?.trim(),
    address.city?.trim(),
    address.state?.name?.trim(),
    address.zipcode?.trim(),
  ];

  return fieldsToCheck.every(field => field != null && field !== '');
};

export default isAddressFilled;
